await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/data-engine-taglib/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

const FIELD_SET = {
	ADD: 'fieldset_add',
	UPDATE: 'fieldset_update',
	UPDATE_LIST: 'fieldset_update_list',
};

const SIDEBAR = {
	FIELD: {BLUR: 'sidebar_field_blur'},
};

const RULE = {
	ADD: 'rule_add',
	CHANGE: 'rule_change',
	DELETE: 'rule_delete',
};

export const EVENT_TYPES = {
	FIELD_SET,
	RULE,
	SIDEBAR,
};
